import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import styles from "../../_css/ContenetManagement.module.css";

const PublishVideoModal = ({ show, onHide, onConfirm, action }) => {
    const navigate = useNavigate();

    // Determine modal title dynamically
    const title = action === "unpublish" ? "Video Unpublished" : "Video Published";

    const handleContinue = () => {
        // Call the confirm action first
        if (onConfirm) {
            onConfirm();
        }
        // Navigate to content management
        navigate('/contentMangement');
        // Close the modal
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-37"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className={styles.publishVideoModalContainer}>
                    {/* Close Icon */}
                    <X
                        onClick={onHide}
                        className={styles.publishVideoModalCloseIcon}
                        size={24}
                    />

                    {/* Header with Image and Title */}
                    <div className={styles.publishVideoModalHeader}>
                        <img
                            className={styles.publishVideoModalImage}
                            src={`${process.env.PUBLIC_URL}/img/tick.png`}
                            alt="Success Icon"
                        />
                        <h1 className={styles.publishVideoModalTitle}>
                            {title}
                        </h1>
                    </div>

                    {/* Continue Button */}
                    <div className={styles.publishVideoModalButtonContainer}>
                        <button
                            className={styles.publishVideoModalContinueButton}
                            onClick={handleContinue}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PublishVideoModal;